import {
  ChangeDetectionStrategy,
  Component,
  computed,
  Input,
  signal,
} from '@angular/core';

import { ExclamationIconComponent } from '@plugins/client/icons/exclamation-icon';

@Component({
  selector: 'plugins-multilanguage-label',
  imports: [ExclamationIconComponent],
  template: `
    <div class="wrapper">
      <span>{{ label() }}</span>
      @if (error()) {
        <icon-exclamation [size]="19" [color]="'#ff0000'" />
      }
    </div>
  `,
  styles: `
    .wrapper {
      display: flex;
      align-items: center;
    }
    span {
      color: inherit;
    }
    icon-exclamation {
      margin-left: 0.5rem;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultilanguageLabelComponent {
  @Input() set language(val: string) {
    this.lang.set(val);
  }
  @Input() set available(val: boolean) {
    this.isAvailable.set(val);
  }
  @Input() set hasError(val: boolean | undefined) {
    this.error.set(!!val);
  }
  private readonly lang = signal<string>('');
  private readonly isAvailable = signal<boolean>(false);

  protected readonly error = signal<boolean>(false);
  protected readonly label = computed(() => {
    const begin = !this.isAvailable() && '(',
      end = !this.isAvailable() && ')';
    return [begin, this.lang(), end].filter(Boolean).join('');
  });
}
